<template>
  <div>
    <NavBar class="_not-dashboard" @searchDashboards="searchDashboards" @createNewDashboard="createNewDashboard"/>
    <b-container
      fluid
      class="home"
      v-if="dashboardsLoaded"
      >
      <div>
        <div
          v-for="(dashboard, key) in filteredDashboards"
          :key="key"
          class="dashboardItem"
          >
            <b-card>
              <b-card-text>
                <a
                  v-if="$can('update', 'Dashboard_' + key)"
                  href="#"
                  class="dashboardItem__edit"
                  @click.prevent="editDashboard(key)"
                  >
                  <icon name="pencil" />
                </a>
                <a
                  v-if="!$can('canNotDelete', 'Dashboard_' + key)"
                  href="#"
                  class="dashboardItem__remove"
                  @click.prevent="removeDashboard(key)"
                  >
                  <icon name="remove" />
                </a>
                <router-link
                  :to="'/dashboard/' + key"
                  class="dashboardItem__trigger"
                  >
                  <span class="dashboardItem__content">
                    &nbsp;
                    <span
                      :id="key"
                      :contenteditable="dashboardToEdit === key && renameStarted"
                      @blur="saveDashboardName"
                      @keydown.enter.stop="blurInput"
                      >{{ dashboard.name }}</span>
                  </span>
                </router-link>
              </b-card-text>
            </b-card>
        </div>
        <div class="dashboardItem">
          <b-card>
            <b-card-text>
              <a
                href="#"
                class="dashboardItem__trigger"
                @click.prevent="createDashboard"
                >
                <span class="dashboardItem__content dashboardItem__add">
                  <h3>Add A New Workspace&nbsp;<icon name="plus-square" /></h3>
                </span>
              </a>
            </b-card-text>
          </b-card>
        </div>
      </div>
      <AddDashboardModal
        ref="addDashboardModal"
        :dashboards="dashboards"
        @dashboardAdded="fetchDashboards"
      />
    </b-container>
  </div>
</template>

<script>
// modules
import { mapState } from 'vuex'
// components
import AddDashboardModal from '@/components/Modals/AddDashboard'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

let $ = window.$

export default {
  components: {
    AddDashboardModal,
  },
  data () {
    return {
      dashboards: {},
      inputVisible: false,
      dashboardName: '',
      dashboardToEdit: '',
      renameStarted: false,
      dashboardsLoaded: false,
      searchText: ''
    }
  },
  computed: {
    ...mapState([
      'userId'
    ]),
    filteredDashboards(){
      if(this.searchText.length){
        let dashboards = {}
        for(let item in this.dashboards){
          if(this.dashboards[item].name.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1){
            dashboards[item] = this.dashboards[item]
          }
        }
        return dashboards
      }else{
        return this.dashboards
      }
    }
  },
  methods: {
    createNewDashboard(){
      this.createDashboard()
    },
    searchDashboards(data){
      this.searchText = data
    },
    fetchDashboards () {
      this.$store.commit('addProcess', {
        process: 'dashboardsLoading'
      })
      this.dashboardsLoaded = false

      db.dashboards.read(this.userId, (dashboards) => {
        this.dashboards = dashboards

        this.dashboardsLoaded = true

        this.$store.commit('deleteProcess', 'dashboardsLoading')

        this.setAccessRules(dashboards)
      })
    },
    createDashboard () {
      this.$refs.addDashboardModal.open()
    },
    removeDashboard (key) {
      let confirm = window.confirm('Are you sure?')
      if (!confirm) return

      this.$store.commit('addProcess', {
        process: 'removeDashboard',
        message: 'Deleting'
      })
      db.dashboards.delete(key, () => {
        db.dashboards.read(this.userId, (dashboards) => {
          this.dashboards = dashboards
          this.$store.commit('deleteProcess', 'removeDashboard')

          this.setAccessRules(dashboards)
        })
      })
    },
    editDashboard (key) {
      this.dashboardToEdit = key
      this.renameStarted = true

      let el = $('#' + key)
      el.focus()
      setTimeout(() => {
        this.$cursorToEnd(el.get(0))
      })
    },
    blurInput () {
      $('#' + this.dashboardToEdit).blur()
    },
    saveDashboardName () {
      db.dashboards.edit(this.dashboardToEdit, $('#' + this.dashboardToEdit).text())
      this.dashboardToEdit = ''
      this.renameStarted = false
    },
    setAccessRules (dashboards) {
      for (let key in dashboards) {
        db.access.dashboard(this.userId, key, (actions) => {
          if (!actions) return
          let rule = this.$buildACLRule('Dashboard_' + key, actions)
          this.$store.commit('updateCaslRules', rule)
        })
      }
    }
  },
  created () {
    document.title = 'Home'

    this.fetchDashboards()
  },
  beforeDestroy () {
    this.dashboards = null
    this.$store.commit('updateCaslRules', null)
    this.$releaseEvents()
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.home {
  position: relative;
  padding-top: 15px;
  height: calc(100vh - 45px);
  overflow: hidden;
  overflow-y: auto;
  > div {
    @include cf;
    margin: 0 -10px;
    @include breakpoint(max-width $screenMd) {
      margin: 0 -10px;
    }
  }
}
.dashboardItem {
  position: relative;
  @include span(3);
  margin-bottom: 15px;
  float: left;
  height: 25vh;
  padding: 0 10px;
  @include breakpoint(max-width $screenMd) {
    @include span(4);
  }
  @include breakpoint(max-width $screenSm) {
    @include span(6);
  }
  @include breakpoint(max-width $screenXs) {
    @include span(12);
  }
  .card {
    height: 100%;
    margin-bottom: 0;
    .card-body {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .card-text {
      width: 100%;
      height: 100%;
    }
  }
  &__trigger {
    display: block;
    height: 100%;
    color: $color2;
    text-decoration: none;
    font: {
      size: 20px;
      family: $font2;
    }
  }
  &:hover,
  &:focus {
    .dashboardItem__content {
      color: $color2;
    }
  }
  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
  }
  &__inputWrapper {
    position: relative;
    position: absolute;
    left: 20px;
    top: 0;
    width: calc(100% - 40px);
    height: 100%;
    @include breakpoint(max-width $screenMd) {
      left: 10px;
      width: calc(100% - 20px);
    }
  }
  &__input {
    position: absolute;
    left: 10px;
    top: calc(50% - 20px);
    width: calc(100% - 20px);
  }
  &__edit,
  &__remove {
    position: absolute;
    top: 5px;
    color: $color3;
    &:hover,
    &:focus {
      color: $color2;
    }
  }
  &__edit {
    right: 32px;
  }
  &__remove {
    right: 12px;
  }
}
.loading {
  padding: {
    left: 15px;
    top: 15px;
  }
}
</style>
